import { BRANCHDATA, CURRENT_USER, LOCATION } from "./ActionType";

const initialState = {
  BranchData: "",
  userData: {},
  userLocation: {}
};

export const mainReducer = (state = initialState, action) => {
  
  switch (action.type) {
    case BRANCHDATA:
      return { ...state, BranchData: action.payload };
    case CURRENT_USER:
      return { ...state, userData: action.payload };
    case LOCATION:
    return { ...state, userLocation: action.payload };
    default:
      return state;
  }
};
